export default "__VITE_ASSET__$ya3_Dym__"